<template>
  <div id="index">
    <Header ref="header"></Header>
    <!-- 报价搜索 -->
    <div class="offerSearch" :class="morenDiv == false ? 'none':''">
      <div>
        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="input2"></el-input>
        <button type="primary" @click="search">搜索</button>
      </div>
      <p class="offerSearchText">报价中采购<span>{{cgCount}}</span>条　　｜　　共有采购<span>{{sum}}</span>条</p>
    </div>
    <div class="offerList" :class="morenDiv == false ? 'none':''">
      <div class="offerListBox">
        <el-collapse v-model="activeNames" accordion>
          <el-collapse-item v-for="item in demandList" :key="item.id" :name="item.id" >
            <template slot="title">
              <div class="offerListTitle">
                <span>{{item.companyName}}</span>
                <img src="../assets/img/offerIcon.png" alt="">
                <span>  采购编号：{{item.id}}</span>
                <span>发布时间：{{item.realseTime}}</span>
                <span>报价截止日期：<b>{{item.endTime}}</b></span>
              </div>
            </template>
            <div class="offerListCon" v-for="item1 in item.demandInfoList" :key="item1.id">
              <div>
                <h5>{{item1.verietiesName}} 　<span>{{item1.skuName}}　| 　湖北</span><b>{{item1.total}}<u>{{item1.unit}}</u> </b></h5>
                <h6>{{item1.requirements}}</h6>
              </div>
              <button  @click="goProductDetails(item.id)">报价</button>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-pagination background layout="prev, pager, next" :currentPage="currentPage" :pageSize ="pageSize" :total="totalNum"  @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="foot">
        <ul>
          <li>电话：0558-5858131</li>
          <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
          <li>安徽广盛堂中药饮片有限公司 版权所有 免责声明 皖ICP备18026442号</li>
          <li>皖公网安备 3416020200060号</li>
        </ul>
        <img src="../assets/img/footerImg.jpg" alt="">
      </div>
    </div>
    <el-dialog :visible.sync="isDialog" width="20%" :before-close="isClose">
      <p>抱歉! 您目前不可以参与报价，请先登录账号信息谢谢。</p>
      <button class="isQueren" @click="isClose">确定</button>
    </el-dialog>
  </div>
</template>
<script>
import Header from '../components/header'
export default {
  components: {
    Header
  },
  data() {
    return {
      isDialog:false,
      morenDiv:true,
      showLogin:true,
      EWMImg:false,
      EWMButton:true,
      input2:'',
      sum:0,
      cgCount:0,
      activeNames: ['1','2','3','4'],
      demandList:[],
      currentPage: 1,//默认显示第一页
      pageSize:10,//默认每页显示10条
      totalNum: 100 //总页数
    }
  },
  mounted() {
    if(this.$cookie.get('account') == null){
      this.showLogin = true
    }else{
      this.showLogin = false
    }
    this.getOfferList();
    this.getQueryCount();
  },
  methods: {
    search(){
      this.$fetch('getOfferList',{keyWord:this.input2,pageNo:this.currentPage,pageSize:this.pageSize}).then(res => {
        this.demandList = res.result.records;
        this.totalNum = res.result.total;
      })
      this.getQueryCount()
    },
    getQueryCount(){
      this.$fetch('getQueryCount',{keyWord:this.input2}).then(res => {
        this.sum = res.result.cgTotalCount;
        this.cgCount = res.result.cgCount;
        console.log(this.sum , this.cgCount)
      })
    },
    //资源列表
    getOfferList(){
      this.$fetch('getOfferList',{pageNo:this.currentPage,pageSize:this.pageSize}).then(res => {
        this.demandList = res.result.records;
        this.totalNum = res.result.total;
      })
    },
    goProductDetails(id){
      if(this.$cookie.get('account') == null){
        this.isDialog = true
      }else{
        this.$router.push({name:'OfferDetails',query: {id:id}})
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;    //动态改变
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getOfferList();
    },
    isClose(){
      this.isDialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/offerList.vue